<template>
  <div class="products-result-base" :style="styles">
    <span class="subtitle">10年間の運命が占える</span>
    <h1>天宝占術のバイオリズム</h1>
    <div class="content-wrap">
      <div class="appearance-block">
        <img class="head-img" src="/static/img/recommend/lp/kanoucoco/products/resultImg_10nen_coco.png">
        <div class="wrap">
          <p class="lead">過去の出来事や、現在のあなたの運勢、未来がどうなり、どうしていけばいいのか知りたくありませんか？迷ったとき、あなたの可能性を最大限に引き出す魔法がここにあります。</p>
          <template v-if="resultList.length > 0">
            <h3>あなたはどんな人？<br>魂のかたち＜アピアランス＞</h3>
            <img class="appearance-img" :src="appearanceData.image">
            <p class="appearance-text" v-html="appearanceData.text"></p>
          </template>

          <div class="regist-birthdate" v-else>
            <span class="regist-message">生年月日が登録されていません</span>
            <form action="" method="post" ref="regbirth">
              <input type="hidden" name="_token" :value="csrfToken">
              <input type="hidden" name="birth_date" :value="formatedBirthdate">
              <form-birthday name="birthday" @change="onBirthdayChange"/>
              <span class="regbirth-err" v-if="regBirthErr.length > 0">{{regBirthErr}}</span>
            </form>
            <span class="btn-submit" :class="{disabled: !regBirthValid}" @click="onRegBirthSubmitClick">登録する</span>
          </div>
        </div>
      </div>
      <div class="result-list-block" v-if="resultList.length > 0">
        <result-item
          v-for="(item, idx) in resultList"
          :key="idx"
          :result-data="item"
          :color-scheme="counselorInfos.colorScheme"
        />
      </div>
    </div>

    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />
    <lp-footer
      :color-scheme="counselorInfos.colorScheme"
      :menu-list="footerMenuList"
      :has-floating-banner="false"
      :scroll-pos="scrollPos"
    />
  </div>
</template>

<script>
import moment from 'moment'
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'

import ResultItem from '@/utvStore/components/Products/partials/ResultItem'
import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'
import LpFooter from '@/utvStore/components/recommend/lp//blocks/LpFooter'

export default {
  name: 'ProductsKanococoResult',
  components: {
    RecommendBlockPlus,
    ResultItem,
    LpFooter,
  },
  props: {
    /*
    appearanceData: {
      type: Object,
      default() {
        return {}
      },
    },
    resultList: {
      type: Array,
      default() {
        return []
      }
    },
     */
    resultData: {
      type: Object,
      default:  null
    },
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      scrollPos: -1,
      regBirthValid: false,
      regBirthErr: '',
      regBirthInit: false,
      regBirthVal: null,
    }
  },
  computed: {
    appearanceData() {
      return this.resultData.kanoucoco_0001_01
    },
    resultList() {
      return this.resultData.kanoucoco_0001_02
    },
    counselorInfos(){
      return BASIC_DATA.kanoucoco
    },
    footerMenuList(){
      return [ ...DEFAULT_FOOTER_MENULIST, ]
    },
    formatedBirthdate(){
      return !!this.regBirthVal ? this.regBirthVal.format('YYYY-MM-DD') : ''
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      }
    },
  },
  mounted(){
    // console.log('resultData:%O', this.resultData)
    // console.log('appearanceData:%O', this.appearanceData)
    // console.log('resultList:%O', this.resultList)
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll(){
      this.scrollPos = window.scrollY
    },
    onBirthdayChange(val){
      if(!this.regBirthInit){
        this.regBirthInit = true
      }else {
        if (val.length === 8) {
          const y = val.substring(0, 4)
          const m = val.substring(4, 6)
          const d = val.substring(6, 8)

          const now = new moment()
          const mom = new moment([+y,+m-1,+d])

          if (mom.isBetween('1940-01-01', now, null, '[)') && mom.isValid()){
            this.regBirthErr = ''
            this.regBirthVal = mom
            this.regBirthValid = true
          }else{
            this.regBirthErr = '正しい日付を入力してください'
            this.regBirthValid = false
            this.regBirthVal = null
          }
        } else {
          this.regBirthErr = ''
          this.regBirthValid = false
          this.regBirthVal = null

        }
      }
    },
    onRegBirthSubmitClick(){
      this.$refs.regbirth.submit()
    }
  }
}</script>

<style lang="scss">
header {
  background: #826a95!important;
}
</style>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
.products-result-base {
  background: url(/static/img/recommend/lp/kanoucoco/bg1.png) repeat left top;
  background-size: 100% auto;
  padding-top: 20px;
  @include mq('w580'){
    padding-top: 40px;
  }
  .content-wrap {
    width: 100%;
    padding: 20px 20px 64px;
  }
}

.subtitle {
  width: 100%;
  display: block;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
  color: var(--key-color);
  margin-bottom: 8px;
  @include mq('w580'){
    font-size: 20px;
    margin-bottom: 16px;
  }
}
h1 {
  font-size: 28px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
  color: var(--key-color);
  margin: 0 0 8px;
  @include mq('w580'){
    font-size: 32px;
    margin: 0 0 16px;
  }
}

.appearance-block {
  padding-top: 37%;
  position: relative;
  margin-bottom: 16px;
  color: #32373f;
  .head-img {
    display: block;
    width: 41.79%;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    position: absolute;
  }
  .wrap {
    background: white;
    padding: 60px 20px 24px;
    @include mq('w580'){
      padding: 100px 40px 40px;
    }
  }
  h3 {
    width: 100%;
    margin: 0 0 24px;
    line-height: 1;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: var(--key-color);
  }
  .lead {
    color: var(--key-color);
    font-size: 16px;
    line-height: 32px;
    margin: 0 0 24px;
  }
  .appearance-img {
    width: 100%;

  }
  .appearance-text {
    @include mq('w580'){
      font-size: 15px;
      line-height: 24px;
    }
  }
}

.regist-birthdate {
  padding: 24px 24px 32px;
  background: var(--mess-bg);
  border-radius: 10px;
  .regist-message {
    font-size: 16px;
    font-weight: bold;
    color: var(--key-color);
    margin-bottom: 16px;
    display: block;
    width: 100%;
    text-align: center;
  }
  /deep/ {
    .calenderForm {
      width: 200px;
      margin: 0 auto 32px;
      background: white;
      @include mq('w580'){
        width: 240px;
      }
    }
    .formGroup {
      margin-bottom: 8px;
      height: 44px;
    }
  }
  .regbirth-err {
    color: red;
    display: block;
    width: 100%;
    text-align: center;
  }
  .btn-submit {
    width: 240px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: white;
    background: var(--key-color);
    border-radius: 40px;
    margin: 24px auto 0;
    cursor: pointer;
    &.disabled {
      background: #e0e0e0;
      pointer-events: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kanococo/ProductsKanococoResult.vue